/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */

/**
 * Response returned when a user profile does not exist.
 */
export const UserProfileMissingResponseValue = {
  kind: "missing",
  exists: false,
} as const;
export type UserProfileMissingResponse = typeof UserProfileMissingResponseValue;
